<div mat-dialog-title>Skapa kund</div>
<mat-dialog-content>
  @if (owner.org) {
    <p>Företaget {{ owner.sub }} kunde inte hittas i EDW</p>
    <p>Ange företagsnamn för att fortsätta</p>

  } @else {
    <p>Inga produkter och tjänster kan hittas på kunden i kundbasen.</p>
    <p>Ange för- och efternamn för att fortsätta</p>

  }
  <div class="form">
    <mat-form-field>
      <mat-label>{{ owner.org ? 'Företagsnamn' : 'Namn' }}</mat-label>
      <input matInput [(ngModel)]="owner.name">
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button [mat-dialog-close]="owner" matButton="filled">Spara</button>
</mat-dialog-actions>